import React from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { FaTachometerAlt, FaPlusCircle, FaHistory, FaUsers, FaChartBar, FaTruck, FaPrescriptionBottle, FaBell, FaSignOutAlt, FaUserCircle } from 'react-icons/fa';
import { useAuth } from '../context/AuthContext';
import './Sidebar.css';

const Sidebar = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/');
  };

  const menuItems = [
    { path: '/dashboard', name: 'Dashboard', icon: <FaTachometerAlt /> },
    { path: '/add-medicine', name: 'Add Medicine', icon: <FaPlusCircle /> },
    { path: '/sales', name: 'Sales History', icon: <FaHistory /> },
    { path: '/customers', name: 'Customers', icon: <FaUsers /> },
    { path: '/reports', name: 'Reports', icon: <FaChartBar /> },
    { path: '/suppliers', name: 'Suppliers', icon: <FaTruck /> },
    { path: '/prescriptions', name: 'Prescriptions', icon: <FaPrescriptionBottle /> },
    { path: '/reminders', name: 'Reminders', icon: <FaBell /> }
  ];

  return (
    <div className="sidebar">
      <div className="sidebar-header">
        <h2>🏥 Pharmacy</h2>
        <p>Management System</p>
      </div>

      <div className="sidebar-user">
        <FaUserCircle className="user-icon" />
        <div className="user-info">
          <span className="user-name">{user?.name || 'User'}</span>
          <span className="user-role">{user?.role || 'pharmacist'}</span>
        </div>
      </div>

      <nav className="sidebar-nav">
        {menuItems.map(item => (
          <NavLink
            key={item.path}
            to={item.path}
            className={({ isActive }) => (isActive ? 'sidebar-link active' : 'sidebar-link')}
          >
            <span className="sidebar-icon">{item.icon}</span>
            <span className="sidebar-text">{item.name}</span>
          </NavLink>
        ))}
      </nav>

      <div className="sidebar-footer">
        <button onClick={handleLogout} className="logout-btn">
          <FaSignOutAlt /> Logout
        </button>
      </div>
    </div>
  );
};

export default Sidebar;